
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AuthService } from '../../services/auth/auth.service';
import { Router, RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-login',
  imports: [
    MatFormFieldModule,
    MatCardModule,
    MatInputModule,
    ReactiveFormsModule,
    MatButtonModule,
    RouterModule,
    MatIconModule
],
  templateUrl: './login.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './login.component.scss'
})
export class LoginComponent {
  /** Login form */
  loginForm: FormGroup;

  /** Error message */
  errorMessage: string = "";

  /** Status on login form submission */
  isSubmitting: boolean = false;

   /** Controls password visibility */
  hidePassword = true;

  /**
   * Default constructor to build login form
   * @param fb 
   * @param _authService
   */
  constructor(
    private fb: FormBuilder,
    private _authService: AuthService,
    private _router: Router,
  ) {
    this.loginForm = this.fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
    });
  }

  /**
   * Handles form submission
   */
  onSubmit(): void {
    if (!this.loginForm.valid || this.isSubmitting) {
      return;
    }
    this.isSubmitting = true;
    this.errorMessage = "";

    const username = this.loginForm.value.username;
    const password = this.loginForm.value.password;

    this._authService.login(username, password).subscribe({
      // On successful login, log the success message and route to home
      next: () => {
        console.log('[LOGIN]: Login successful');
        this._router.navigate(['/']);
        this.isSubmitting = false;
      },
      // On error, log the error message and display an error to the user
      error: (errorMsg: string) => {
        console.error('[LOGIN]: Login failed:', errorMsg);
        this.errorMessage = errorMsg || 'Login failed. Please try again.';
        this.isSubmitting = false;
      }
    });
  }
}
